// extracted by mini-css-extract-plugin
module.exports = {"container":"Address_container__H2Cdr","addressContainer":"Address_addressContainer__3Z8W2","newAddress":"Address_newAddress__3EPXk","linkStyle":"Address_linkStyle__1TMfZ"};